import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { OrganisationalLevelFormComponent } from '../organisational-level-form/organisational-level-form.component';
import {
  CreateCompanyOrganisationalLevelRequest,
  CompanyOrganisationalLevelResponse,
} from '../../company.model';

@Component({
  selector: 'app-organisational-level-modal',
  imports: [MatDialogModule, ...SharedMaterialUIModule, OrganisationalLevelFormComponent],
  templateUrl: './organisational-level-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganisationalLevelModalComponent {
  private readonly dialogRef = inject(MatDialogRef<OrganisationalLevelModalComponent>);

  readonly companyId = input.required<string>();
  readonly initialValue = input<CompanyOrganisationalLevelResponse | null>(null);
  readonly saving = input(false);

  protected onSubmit(request: CreateCompanyOrganisationalLevelRequest): void {
    this.dialogRef.close(request);
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }

  protected get title(): string {
    return this.initialValue() ? 'Edit organisational level' : 'Create organisational level';
  }
}